// extracted by mini-css-extract-plugin
module.exports = {"wrapperFilter":"ModalDetailBagging_wrapperFilter__2hSjS","filterColumn":"ModalDetailBagging_filterColumn__1RIVM","actionFilter":"ModalDetailBagging_actionFilter__2-OSe"};